import { redirectIfNotAuthenticated } from '../actions/user';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { authDecisionPendingSelector, userIdSelector } from '../helpers/selectors';
import { Outlet } from 'react-router-dom';
import AppSpinner from '../components/partials/AppSpinner';

export default function Authenticated({ location }) {
  const dispatch = useDispatch();
  const userId = useSelector(userIdSelector);
  const decisionPending = useSelector(authDecisionPendingSelector);

  const [redirected, setRedirected] = useState(false);

  useEffect(() => {
    console.log('[KC-DEBUG] Authenticated.js/useEffect: DECISION - userId first, then the pending auth decision or our own login (settled and still no userId => redirectIfNotAuthenticated => home + session-expired popup)', { userId, hasUserId: Boolean(userId), decisionPending, redirected, pathname: location?.pathname }); // eslint-disable-line no-console
    // Already in, whoever let him in: a Keycloak session restored by check-sso, a
    // legacy or impersonation token (store.js:51-54, which never waits for Keycloak at
    // all), the user slice rehydrated from sessionStorage on F5. Asked first so that
    // none of those is held behind an init that may not even be running.
    if (userId) {
      console.log('[KC-DEBUG] Authenticated.js/useEffect: userId present => rendering the protected route', { userId, redirected, pathname: location?.pathname }); // eslint-disable-line no-console
      setRedirected(false);
      return;
    }

    // Nobody yet - and that is no verdict until Keycloak, then GET /me, and any
    // legacy/impersonation login have given theirs. A hard refresh in a fresh tab
    // looks exactly like an anonymous visitor until they do.
    if (decisionPending) {
      console.log('[KC-DEBUG] Authenticated.js/useEffect: WAITING - the auth decision is still pending (kc.init(), GET /me, or our own login has not answered), so the route holds instead of deciding', { userId, decisionPending, pathname: location?.pathname }); // eslint-disable-line no-console
      return;
    }

    if (!redirected) {
      console.log('[KC-DEBUG] Authenticated.js/useEffect: decision settled with NO userId => redirectIfNotAuthenticated (this is what the user sees when the KC restore silently failed)', { userId, redirected, pathname: location?.pathname, atIso: new Date().toISOString(), perfNowMs: Math.round(performance.now()) }); // eslint-disable-line no-console
      setRedirected(true);
      dispatch(redirectIfNotAuthenticated());
    } else {
      console.log('[KC-DEBUG] Authenticated.js/useEffect: NO userId but already redirected once => doing nothing', { userId, redirected, pathname: location?.pathname }); // eslint-disable-line no-console
    }
  }, [userId, location, decisionPending]);

  if (userId) return <Outlet />;
  // The full-page loader normally covers the Keycloak leg. This remains the route's
  // own safety net for the later /me and legacy/impersonation login windows.
  if (decisionPending) return <AppSpinner className="app-loader-inline" />;
  return null;
}
